import { Box } from '@mui/material';
import CommunicationsPreview from 'components/communications-preview/communications-preview.component';
import AccountInboxListView from 'pages/account-inbox/account-inbox-list-view/account-inbox-list-view.component';
import React from 'react';
import { useViewMessages } from './view-messages.hooks';

const ViewMessages = () => {
  const props = useViewMessages();
  return (
    <CommunicationsPreview>
      <Box data-testid="ViewMessages.List">
        <AccountInboxListView {...props} preview />
      </Box>
    </CommunicationsPreview>
  );
};

export default ViewMessages;
